import { post, postJson } from '@/utils/request';

// 设备管理
// 列表
export const getDeviceList = params => {
  return post(`/app/device/getDeviceList`, params);
};
// 详情
export const getDeviceById = params => {
  return post(`/app/device/getDeviceById`, params);
};
// 新增/编辑
export const editDevice = params => {
  return post(`/app/device/editDevice`, params);
};
// 删除
export const deleteDeviceById = params => {
  return post(`/app/device/deleteDeviceById`, params);
};
// 计量校准
export const editDeviceCalibrate = params => {
  return post(`/app/device/editDeviceCalibrate`, params);
};
// 删除计量记录
export const deleteDeviceCalibrateById = params => {
  return post(`/app/device/deleteDeviceCalibrateById`, params);
};
//  获取计量记录详情
export const getDeviceCalibrateById = params => {
  return post(`/app/device/getDeviceCalibrateById`, params);
};
// 设备校准记录
export const getDeviceCalibrateList = params => {
  return post(`/app/device/getDeviceCalibrateList`, params);
};
